/* istanbul ignore file */
import React, { useMemo, useCallback } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { TutorialTooltip, ApplicationHeader, AdcSearch } from '@adc/ui-adc'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const SearchHeaderWithNotifications = ({
  featureFlags,
  filters,
  user,
  onLocationSuggestionSelect,
  customMobileContent,
  newMobileHeaderSaveButton,
  recognizedLocations,
  notificationDismissed,
}) => {
  const onSearchSubmit = useCallback(
    suggestion => {
      if (suggestion.type === 'address') {
        window.location.assign(suggestion.link)
      } else {
        onLocationSuggestionSelect(suggestion)
      }
    },
    [onLocationSuggestionSelect]
  )
  // this is needed to keep it comaptible with locationSuggestions hook
  const apiFiltersForHeaderSearch = _.omitBy(
    {
      property_city: filters.city[0],
      property_county: filters.county[0],
      property_state: filters.state[0],
      property_zip: filters.zip[0],
      locations: filters.locations,
      search: filters.search,
      global_search: filters.globalSearch === 'y' ? 'y' : '',
    },
    _.isEmpty
  )

  const isNewNavigationEnabled = featureFlags['fe.resi.enable-new-navigation']
  const loggedInUser = user.logged_in ? user : null

  const newMobileHeaderContent = useMemo(
    () => (
      <div className={cx('new-mobile-header-content')}>
        <AdcSearch
          elmId='srp_mobile_search'
          user={loggedInUser}
          filters={apiFiltersForHeaderSearch}
          recognizedLocations={recognizedLocations}
          onSearchSubmit={onSearchSubmit}
          categorizeResults
          variant='new-mobile-header'
        />
        {newMobileHeaderSaveButton}
      </div>
    ),
    [
      loggedInUser,
      apiFiltersForHeaderSearch,
      recognizedLocations,
      onSearchSubmit,
      newMobileHeaderSaveButton,
    ]
  )

  const headerProps = useMemo(
    () => ({
      loadGoogleMaps: false,
      user: loggedInUser,
      onSearchSubmit,
      redirectOnSelected: false,
      showLiveChat: true,
      featureFlags,
      notificationDismissed,
      filters: apiFiltersForHeaderSearch,
      recognizedLocations,
      customMobileContent,
      ...(isNewNavigationEnabled && {
        enableNewMobileHeader: true,
        customMobileContent: newMobileHeaderContent,
        newMobileHeaderLogoVariant: 'icon',
        newMobileHeaderHideShadow: true,
      }),
    }),
    [
      loggedInUser,
      onSearchSubmit,
      featureFlags,
      notificationDismissed,
      apiFiltersForHeaderSearch,
      recognizedLocations,
      customMobileContent,
      isNewNavigationEnabled,
      newMobileHeaderContent,
    ]
  )

  return (
    <TutorialTooltip
      tutorial={1}
      position='bottom left'
      mobilePosition='bottom center'
      elmId='header_tutorial'
      header='Search Where You Want'
      content='Find your next investment in your area of interest.'
    >
      <ApplicationHeader
        headerProps={headerProps}
        featureFlags={featureFlags}
      />
    </TutorialTooltip>
  )
}

SearchHeaderWithNotifications.propTypes = {
  featureFlags: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  onLocationSuggestionSelect: PropTypes.func.isRequired,
  customMobileContent: PropTypes.node,
  newMobileHeaderSaveButton: PropTypes.node,
  recognizedLocations: PropTypes.array,
  notificationDismissed: PropTypes.bool,
}

export default SearchHeaderWithNotifications
